import { toAction } from '../../lib';
import * as actions from './constants';

export const setHasArchived = (dispatch, remoteHasArchived) =>
  dispatch(toAction(actions.SET_HAS_ARCHIVED, remoteHasArchived));

export const fetchDocumentSagaWatchAction = mailbox =>
  toAction(actions.WATCH_FETCH_DOCUMENT, { mailbox });
